import { AlertCircle } from "lucide-react"
import { Button } from "@/shared/ui/button"

interface LoadErrorStateProps {
	message?: string
	onRetry?: () => void
}

/** Generic error placeholder for failed data loads, with an optional retry button. */
export function LoadErrorState({
	message = "Не удалось загрузить данные. Проверьте подключение и попробуйте снова.",
	onRetry,
}: LoadErrorStateProps) {
	return (
		<div className="rounded-xl border border-dashed border-destructive/40 bg-destructive/5 py-10 px-4 text-center">
			<AlertCircle className="mx-auto mb-3 h-8 w-8 text-destructive/80" />
			<p className="text-sm text-muted-foreground">{message}</p>
			{onRetry ? (
				<Button type="button" variant="outline" size="sm" className="mt-4" onClick={onRetry}>
					Повторить
				</Button>
			) : null}
		</div>
	)
}
